














































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { toDCM } from '@/helper'
import moment from 'moment'
import { Validators } from '@/services/currentValidator/model'

@Component({
    components: {},
    filters: {
        DCM(val: number) {
            return parseFloat(toDCM(val).toFixed(9)).toLocaleString('en-US')
        },
    },
})
export default class ValidatorDataTable extends Vue {
    @Prop() validators!: Validators

    toDCM(value: string | number) {
        return parseFloat(toDCM(value).toFixed(9)).toLocaleString('en-US')
    }

    toNow(time: string) {
        return moment(parseInt(time) * 1000).fromNow(true)
    }

    get headers(): any[] {
        return [
            {
                text: 'NodeID',
                value: 'nodeID',
                sortable: true,
                width: '2fr',
            },
            {
                text: 'Stake Amount',
                value: 'stakeAmount',
                sortable: true,
                width: '1fr',
            },
            {
                text: 'Delegators',
                value: 'delegators',
                sortable: true,
                width: '1fr',
            },
            {
                text: 'Uptime',
                value: 'uptime',
                sortable: true,
                width: '1fr',
            },
            {
                text: 'Ends In',
                value: 'endTime',
                sortable: false,
                width: '1fr',
            },
            {
                text: 'Reward',
                value: 'potentialReward',
                sortable: true,
                width: '1fr',
            },
        ]
    }
}
